import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import type { AxiosResponse } from 'axios';

import { KBApi } from '../api';
import { ArticleHighlights } from '../components/ArticleHighlights';
import ArticleList from '../components/ArticleList';
import SectionsList from '../components/SectionsList';
import { ErrorContext } from '../context/ErrorContext';
import { IsLoadingContext } from '../context/IsLoadingContext';
import { ViewContext } from '../context/ViewContext';

import type { FrontpageResponseData } from '../types';

export const FrontPage = () => {
  const { isLoading, setIsLoading } = useContext(IsLoadingContext);
  const { error, setError } = useContext(ErrorContext);
  const { data, setData } = useContext(ViewContext);
  const { t } = useTranslation();
  const params = useParams();

  // FIXME: copy/paste solution for now, looks to be good variant to try RTK query
  const fetchFrontpage = async () => {
    if (!params.hash) {
      setError('Unknown page.');
      return;
    }
    try {
      const response: AxiosResponse<FrontpageResponseData> = await KBApi.getFrontpage(params.hash as string);
      setData(response.data);
      setError(undefined);
    } catch (error) {
      console.error('Error fetching Frontpage', error);
      setError('Error fetching Frontpage');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <p>{t('loading')}</p>}
      {!!error && <button onClick={fetchFrontpage}>{t('try_again')}</button>}
      {!isLoading && !!data && (
        <React.Fragment>
          <div className="flex flex-row mt-10">
            <ArticleList viewHash={params.hash ?? ''} articles={data.frontpage} />
            <ArticleHighlights articles={data.highlights} params={params} />
          </div>
          <SectionsList sections={data.sections ?? []} />
        </React.Fragment>
      )}
    </>
  );
};
